import ShortcutNotification from "./ShortcutNotification";

export default ShortcutNotification;
